import { render, staticRenderFns } from "./CreateStaticMap.vue?vue&type=template&id=06d729e0&lang=pug"
import script from "./CreateStaticMap.vue?vue&type=script&lang=js"
export * from "./CreateStaticMap.vue?vue&type=script&lang=js"
import style0 from "./CreateStaticMap.vue?vue&type=style&index=0&id=06d729e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports